// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "frontend-assets/css/" + chunkId + "." + {"91":"241f3400","120":"cabed3cc","180":"7c330c72","576":"080e3cb2","722":"1878463f","871":"e700bf3e","922":"b6462807"}[chunkId] + ".css";
};